/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @version 1.22.0
 * @since 1.22.0
 */

import { createAction } from '@modules/app/createAction';

import {
    WIZARD_ORDER_REPORT_HANDLE_NEXT,
    WIZARD_ORDER_REPORT_SET_PARAMS,
    WIZARD_ORDER_REPORT_SET_STEP_VALID,
} from './constants';
import {
    IWizardOrderReportSetStepValidPayload,
    TWizardOrderReportDataSetParamsAction,
    TWizardOrderReportHandleNextAction,
    TWizardOrderReportSetParamsPayload,
    TWizardOrderReportSetStepValidAction,
} from './types';

/*
 * -------------------------------------------
 *         Common Wizard Actions
 * -------------------------------------------
 */

export const wizardOrderReportHandleNextAction = (): TWizardOrderReportHandleNextAction =>
    createAction(WIZARD_ORDER_REPORT_HANDLE_NEXT);

export const wizardMultiSearchSetStepValidAction = (
    payload: IWizardOrderReportSetStepValidPayload,
): TWizardOrderReportSetStepValidAction => createAction(WIZARD_ORDER_REPORT_SET_STEP_VALID, payload);

export const wizardOrderReportSetParamsAction = (
    payload: TWizardOrderReportSetParamsPayload,
): TWizardOrderReportDataSetParamsAction => createAction(WIZARD_ORDER_REPORT_SET_PARAMS, payload);
